/** The GRC_ENVIRONMENT / VITE_GRC_ENVIRONMENT value of the production deployment. */
export const PRODUCTION_ENVIRONMENT = 'prod';
export const isProductionEnvironment = (environment) => environment === PRODUCTION_ENVIRONMENT;
/** The status to show: always 'published' in production, the real status everywhere else. */
export function contentStatusFor(status, environment) {
    return isProductionEnvironment(environment) ? 'published' : status;
}
/** True when a draft label for this National content should be shown. */
export const showsDraftLabel = (status, environment) => contentStatusFor(status, environment) === 'draft';
//# sourceMappingURL=content-status.js.map